import { render, staticRenderFns } from "./PanoramaxPlugin.vue?vue&type=template&id=18ec89a1&scoped=true"
import script from "./PanoramaxPlugin.vue?vue&type=script&lang=ts"
export * from "./PanoramaxPlugin.vue?vue&type=script&lang=ts"
import style0 from "./PanoramaxPlugin.vue?vue&type=style&index=0&id=18ec89a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec89a1",
  null
  
)

export default component.exports